import { useState } from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/util';

import ProductFilterContainer from '../../../../containers/common/product-filter/ProductFilter.container';
import ProductListing from '../../../common/listing/product-listing/ProductListing';

import { ReactComponent as Bookmarked } from '../../../../resources/icons/star-filled.svg';
import { ReactComponent as UnBookmarked } from '../../../../resources/icons/star-empty.svg';
import { ReactComponent as DoubleArrow } from '../../../../resources/icons/arrow-double.svg';

import './market-product-listings.scss';

const MarketProductListings = ({ listings, applyFilters, isProductBookmarked, updateBookmark, currencyCode }) => {
  const [miniView, setMiniView] = useState(true);

  const navigate = useNavigate();

  const renderMiniViewHeaders = () => (
    <section className="market-product-listings__mini-headers">
      <p>Product</p>
      <p>{currencyCode} Price/Product Unit</p>
      <p>Available Date</p>
      <span />
    </section>
  );

  const renderListings = () => {
    if (listings.length === 0) {
      return <p className="market-product-listings__no-listings">No Listings</p>;
    }

    return (
      <>
        {miniView && renderMiniViewHeaders()}
        {listings.map((listing) => {
          const actions = (
            <div className={getClassNames('market-product-listings__buttons', { mini: miniView })}>
              <div
                className={getClassNames('market-product-listings__bookmarked', {
                  'is-un-bookmarked': !isProductBookmarked(listing.productExternalReference),
                })}
                onClick={() => updateBookmark(listing.productExternalReference)}
              >
                <h1>Bookmark This</h1>
                {isProductBookmarked(listing.productExternalReference) ? <Bookmarked /> : <UnBookmarked />}
              </div>{' '}
              <div
                className="market-product-listings__page"
                onClick={() => navigate(`/market/product-listing/${listing.productExternalReference}`)}
              >
                <h1>View Product Page</h1>
                <DoubleArrow />
              </div>
            </div>
          );

          return (
            <ProductListing
              key={listing.productExternalReference}
              listing={listing}
              actions={actions}
              mini={miniView}
            />
          );
        })}
      </>
    );
  };

  return (
    <section className="market-product-listings" data-testid="product-listings">
      <ProductFilterContainer onApplyFiltersClick={applyFilters} />

      <section className="market-product-listings__cards">
        <section className="market-product-listings__card">
          <div className="market-product-listings__card__header">
            <h1 className="market-product-listings__card__header-text">Product Listings</h1>
            <div className={getClassNames('market-product-listings__card__header-buttons', { mini: miniView })}>
              <button onClick={() => setMiniView(!miniView)}>Switch View</button>
              <button onClick={() => navigate('/shop/upload-product-listing')}>
                <span />
                Upload New
              </button>
            </div>
          </div>
          {renderListings()}
        </section>
      </section>
    </section>
  );
};

MarketProductListings.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({})),
  applyFilters: PropTypes.func.isRequired,
  isProductBookmarked: PropTypes.func.isRequired,
  updateBookmark: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
};

MarketProductListings.defaultProps = {
  listings: [],
};

export default MarketProductListings;
